// extracted by mini-css-extract-plugin
module.exports = {"font-family-base":"var(--font-armingrotesk),\"ArminGrotesk\",\"Adjusted Fallback Font\",sans-serif"};